import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-tertullian',
  imports: [Link],
  templateUrl: './tertullian.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tertullian.scss',
})
export class Tertullian {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Tertullian`);
    this.dynamicTitle.description(`Tertullian is known for his apologetic works that defended Christianity against pagan criticisms.`);
  }
}
